import type {FeatureData} from './catalog';
import type {ChoiceInstance} from './feature-tree';

export const isPreparedOnSheet = (choice: ChoiceInstance, feature: FeatureData | undefined) => {
	const mode = feature?.props?.spellcasting?.mode;
	return (
		choice.group.type === 'spell' && !!choice.group.params.prepared && (mode === 'prepared' || mode === 'spellbook')
	);
};

/** заклинания в книгу за уровень: в мастере не выбираются, книгу пополняют на листе и при повышении уровня */
export const isSpellbookLevelUp = (choice: ChoiceInstance, feature: FeatureData | undefined) =>
	choice.group.type === 'spell' &&
	choice.group.change === 'eachLevel' &&
	feature?.props?.spellcasting?.mode === 'spellbook';

/** выбор делается на листе, а не в мастере */
export const isManagedOnSheet = (choice: ChoiceInstance, feature: FeatureData | undefined) =>
	isPreparedOnSheet(choice, feature) || isSpellbookLevelUp(choice, feature);
